module.exports = __webpack_public_path__ + "img/videocloud.8d90fb88.png";